import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSinglePhotoSession = async ({ caseId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/single_photo_session/${caseId}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetSinglePhotoSession = ({ caseId, enabled = true }) => {
  return useQuery({
    queryKey: ["single_photo_session", caseId],
    queryFn: () => fetchSinglePhotoSession({ caseId }),
    enabled: enabled && Boolean(caseId),
  });
};

export default useGetSinglePhotoSession;
